export function isIOS(): boolean {
  const userAgent = navigator.userAgent;
  // iPhone/iPad/iPod clássicos
  if (/\b(iPhone|iPad|iPod)\b/i.test(userAgent)) return true;

  // iPadOS 13+ reporta "MacIntel", então detecte "Mac" + touch
  if (typeof navigator !== 'undefined') {
    const platform = navigator.platform || '';
    const hasTouch = navigator.maxTouchPoints > 1 || 'ontouchend' in globalThis.document;
    if (/^Mac/i.test(platform) && hasTouch) return true;
  }

  return false;
}
